export default "__VITE_ASSET__C_p9BWHy__"